import React from "react";
import Error from "../Components/Error/Error";
import Seo from "../Components/Seo/Seo";
import { useSiteSeo } from "../context/SiteSeoContext";
import { useLocation } from "react-router-dom";
import { usePrerenderReady } from "../utils/prerenderReady";

const NotFound = () => {
  usePrerenderReady(true);
  const { pathname } = useLocation();
  const siteCtx = useSiteSeo();
  const titleSuffix =
    siteCtx.organization_name && String(siteCtx.organization_name).trim()
      ? ` | ${String(siteCtx.organization_name).trim()}`
      : " | Gem Fashion Studios";

  return (
    <>
      <Seo
        title={`Page not found${titleSuffix}`}
        description="This page does not exist or the link is incorrect."
        canonicalPath={pathname === "/" ? "/" : pathname}
        noindex
      />
      <Error />
    </>
  );
};

export default NotFound;
